var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "svg",
      {
        attrs: {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      [
        _c("rect", {
          attrs: {
            x: "0.5",
            y: "0.5",
            width: "19",
            height: "19",
            rx: "9.5",
            stroke: "#B3B3B3",
          },
        }),
        _c("path", {
          attrs: {
            d: "M11.6667 6V14H10.4724V7.45403C9.9733 7.94625 9.25435 8.28571 8.33337 8.47242V7.2843C9.27812 7.08628 10.0505 6.65629 10.6388 6H11.6667Z",
            fill: "#666666",
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }